import React, { useCallback, useMemo } from "react";
import clsx from "clsx";
import { Col, Row } from "react-bootstrap";
import { useDispatch } from "react-redux";

import { Skeleton, Button } from "components";
import { UserProfileFields } from "globalConstants";
import { useLoader } from "hooks";
import { uiActions } from "store";

import { ReactComponent as CopyIcon } from "static/images/copy_icon.svg";
import styles from "../userForm.module.scss";

const REACT_APP_JARIS_URL = process.env.REACT_APP_JARIS_URL || "";

const { AgentId, CompanyId } = UserProfileFields;

type JarisUrlProps = {
	isLoading: boolean;
	defaultValues: { [key: string]: any } | undefined;
};

const JarisUrl = ({ isLoading, defaultValues }: JarisUrlProps) => {
	const dispatch = useDispatch();

	const agentId = defaultValues?.[AgentId.name];
	const companyId = defaultValues?.[CompanyId.name];

	const jarisUrl = useMemo(
		() =>
			`${REACT_APP_JARIS_URL}/aurora/referral?referral-id=${
				agentId || ""
			}&channel-id=${companyId || ""}`,
		[agentId, companyId],
	);

	const handleCopyJarisUrl = useCallback(() => {
		navigator.clipboard.writeText(jarisUrl);

		dispatch(
			uiActions.showSuccessNotification({
				title: "Jaris URL copied",
				delay: 1500,
			}),
		);
	}, [jarisUrl, dispatch]);

	const Loader = useLoader(isLoading);

	return (
		<>
			<hr className={`${styles.divider} mt-2`} />
			<Row className={styles.aliasBlock}>
				<Col lg={5}>
					<h3 className={styles.title}>URL for Jaris</h3>
					<div className={styles.urlContainer}>
						<Loader
							skeleton={<Skeleton variant="text" width={160} />}
							component={
								<span
									className={clsx(styles.url, "url-disabled")}
								>
									{jarisUrl}
								</span>
							}
						/>
						<div className={styles.urlActions}>
							<Button
								onClick={handleCopyJarisUrl}
								disabled={isLoading}
								icon={<CopyIcon />}
								btnIcon
								variant="secondary"
								size="sm"
								title="Copy Link"
							/>
						</div>
					</div>
				</Col>
			</Row>
		</>
	);
};

export default JarisUrl;
